import { ParticipationCriteriaItem } from '../../../types/events/common.types';

import { ReferralParticipationCriteriaSection } from '../types/';

/**
 * Maps participation criteria from API to frontend format.
 * API structure:
 * - label: section title (e.g., "Event Timeline", "Eligibility")
 * - value: section description/content
 * - order: display order (0, 1, 2, ...)
 */
export const mapParticipationCriteria = (
  apiCriteria: ParticipationCriteriaItem[]
): ReferralParticipationCriteriaSection[] => {
  if (!apiCriteria || apiCriteria.length === 0) {
    return [];
  }

  return apiCriteria
    .sort((a, b) => a.order - b.order)
    .map((item) => ({
      title: item.label,
      description: item.value || item.description,
    }));
};
